// SavedItem.js
export const SavedItem = {
  list: async () => [],
  filter: async (query) => [],
  create: async (item) => {},
  delete: async (id) => {}
};
